module.exports = __webpack_public_path__ + "img/icon_Information-Services.24fef40a.svg";